const GENERIC_ERROR = 'GENERIC_ERROR';
const FORM_ERROR = 'FORM_ERROR';
const MAX_NAME_LENGTH = 50;
const MAX_DESCRIPTION_LENGTH = 150;

const automations_dataAnalytics = {
  select_shippingDestType:
    'automations_condition_addRuleForm_select_shippingDestinationConditionValue',
  input_shipToState: 'automations_condition_addRuleForm_input_shipToStatesConditionValue',
  input_shipToZipcode: 'automations_condition_addRuleForm_input_shipToZipcodesConditionValue',
  input_shipToCountries: 'automations_condition_addRuleForm_input_shipToCountriesConditionValue',
};

const ShippingCountryType = {
  CA_country: 'CA_country',
  CA_state: 'CA_state',
  CA_zipcode: 'CA_zipcode',
  US_country: 'US_country',
  US_state: 'US_state',
  US_zipcode: 'US_zipcode',
  ALL_country: 'ALL_country',
};

type ConditionFormData = {
  filterGroup: string;
  operator: string;
  units?: string;
  weight?: number;
  productName?: string;
  sku?: string;
  orderItemQuantity?: number;
  shippingDestination?: string;
  states?: string[];
  zipcodes?: string;
  countries?: string[];
};

enum ConditionFilterType {
  WEIGHT = 'WEIGHT',
  PRODUCT_NAME = 'PRODUCT_NAME',
  DEFAULT = '',
  ITEM_SKU = 'ITEM_SKU',
  ORDER_ITEM_QUANTITY = 'ORDER_ITEM_QUANTITY',
  SHIPPING_DESTINATION = 'SHIPPING_DESTINATION',
  IS_INTERNATIONAL = 'IS_INTERNATIONAL',
  SHIPPING_ZIPCODES = 'SHIPPING_ZIPCODES',
  SHIPPING_STATES = 'SHIPPING_STATES',
  SHIPPING_COUNTRIES = 'SHIPPING_COUNTRIES',
}

enum ActionType {
  DEFAULT = '',
  PARCEL_TEMPLATE = 'PARCEL_TEMPLATE',
  SERVICE_LEVEL = 'SERVICE_LEVEL',
  SENDER_ADDRESS = 'SENDER_ADDRESS',
}

type ConditionOptionsType = {
  [ConditionFilterType.WEIGHT]?: string;
  [ConditionFilterType.PRODUCT_NAME]?: string;
  [ConditionFilterType.WEIGHT]?: string;
  [ConditionFilterType.DEFAULT]?: string;
  [ConditionFilterType.ITEM_SKU]?: string;
  [ConditionFilterType.ORDER_ITEM_QUANTITY]?: string;
  [ConditionFilterType.SHIPPING_DESTINATION]?: string;
  [ConditionFilterType.IS_INTERNATIONAL]?: string;
  [ConditionFilterType.SHIPPING_ZIPCODES]?: string;
  [ConditionFilterType.SHIPPING_STATES]?: string;
  [ConditionFilterType.SHIPPING_COUNTRIES]?: string;
};

export {
  FORM_ERROR,
  GENERIC_ERROR,
  MAX_DESCRIPTION_LENGTH,
  MAX_NAME_LENGTH,
  ConditionFormData,
  ConditionFilterType,
  ActionType,
  ConditionOptionsType,
  ShippingCountryType,
  automations_dataAnalytics,
};
